/* WOD.LOL — suggestions du tiroir panier (snippets/wl-cart-upsell.liquid)
   Délégation d'événements : le tiroir panier est re-rendu en innerHTML à chaque
   mise à jour, donc rien n'est attaché directement aux cartes.
   5 oct 2026 : 3FOR15 vs cadeaux automatiques (patch brodé, porte-clés WDLL).
   Shopify réserve les vêtements qui déclenchent un « Achetez X, obtenez Y » : ils ne peuvent plus
   recevoir 3FOR15 → le code restait « non applicable » sans rien afficher. Désormais :
   - 6 oct : les réductions patch / porte-clés sont « non cumulables » avec les réductions produit,
     Shopify garde la meilleure option (cadeau à prix normal si 3FOR15 gagne) ; le bouton
     « Appliquer 3FOR15 » l'explique par un message ;
   - ajout d'un cadeau depuis le tiroir alors que 3FOR15 est actif : si ça annule 3FOR15, on annule
     l'ajout et on l'explique. */
(function () {
  'use strict';

  var lang = (document.documentElement.lang || 'fr').slice(0, 2).toLowerCase();
  var MSG = {
    fr: {
      paid: '3FOR15 appliqué : tu économises {code}. Il ne se cumule pas avec ton cadeau offert, qui repasse à prix normal ({gift}). Tu peux le garder ou le retirer.',
      kept: '3FOR15 ne se cumule pas avec ton cadeau offert sur ces hauts. On garde le cadeau, plus avantageux ({gift}).',
      blocked: 'Ce cadeau ne se cumule pas avec 3FOR15 sur tes hauts : on garde 3FOR15, plus avantageux.',
      na: '3FOR15 ne s’applique pas encore à ce panier.'
    },
    en: {
      paid: '3FOR15 applied: you save {code}. It can’t be combined with your free gift, which is back to full price ({gift}). Keep it or remove it.',
      kept: '3FOR15 can’t be combined with your free gift on these tops. We kept the gift, it saves you more ({gift}).',
      blocked: 'This gift can’t be combined with 3FOR15 on your tops: we kept 3FOR15, it saves you more.',
      na: '3FOR15 doesn’t apply to this cart yet.'
    },
    es: {
      paid: '3FOR15 aplicado: ahorras {code}. No se acumula con tu regalo, que vuelve a precio normal ({gift}). Puedes quedártelo o quitarlo.',
      kept: '3FOR15 no se acumula con tu regalo en estos tops. Mantenemos el regalo, es más ventajoso ({gift}).',
      blocked: 'Este regalo no se acumula con 3FOR15 en tus tops: mantenemos 3FOR15, es más ventajoso.',
      na: '3FOR15 aún no se aplica a este carrito.'
    },
    de: {
      paid: '3FOR15 angewendet: du sparst {code}. Nicht mit deinem Geschenk kombinierbar, es kostet jetzt wieder den normalen Preis ({gift}). Behalten oder entfernen.',
      kept: '3FOR15 ist bei diesen Oberteilen nicht mit deinem Geschenk kombinierbar. Wir behalten das Geschenk, es bringt mehr ({gift}).',
      blocked: 'Dieses Geschenk ist nicht mit 3FOR15 kombinierbar: wir behalten 3FOR15, es bringt mehr.',
      na: '3FOR15 gilt noch nicht für diesen Warenkorb.'
    }
  };
  var M = MSG[lang] || MSG.fr;
  var money = function (c) {
    return (c / 100).toLocaleString(lang === 'en' ? 'en-IE' : lang + '-' + lang.toUpperCase(), { style: 'currency', currency: 'EUR' });
  };
  var JSONH = { 'Content-Type': 'application/json', Accept: 'application/json' };
  var getCart = function () { return fetch('/cart.js', { credentials: 'same-origin' }).then(function (r) { return r.json(); }); };
  var changeLine = function (key, qty) {
    return fetch('/cart/change.js', { method: 'POST', credentials: 'same-origin', headers: JSONH, body: JSON.stringify({ id: key, quantity: qty }) });
  };
  var setCodes = function (codes) {
    return fetch('/cart/update.js', { method: 'POST', credentials: 'same-origin', headers: JSONH, body: JSON.stringify({ discount: codes.join(',') }) });
  };
  var codeState = function (cart, code) {
    var up = code.toUpperCase();
    return (cart.discount_codes || []).filter(function (d) { return String(d.code).toUpperCase() === up; })[0] || null;
  };
  var codeSaving = function (cart, code) {
    var up = code.toUpperCase();
    var s = 0;
    (cart.items || []).forEach(function (it) {
      (it.line_level_discount_allocations || []).forEach(function (a) {
        if (String(a.discount_application.title).toUpperCase() === up) s += a.amount;
      });
    });
    return s;
  };
  // lignes offertes / remisées par les offres cadeaux automatiques (patch brodé, porte-clés WDLL),
  // avec leur valeur — jamais un vêtement remisé par une autre réduction
  var GIFT_RE = /patch|porte-cl/i;
  var giftLines = function (cart) {
    return (cart.items || []).map(function (it) {
      var v = 0;
      (it.line_level_discount_allocations || []).forEach(function (a) {
        // /cart.js renvoie type "" (pas "automatic") pour les réductions automatiques
        if (a.discount_application.type !== 'discount_code' && a.amount > 0 && GIFT_RE.test(a.discount_application.title)) v += a.amount;
      });
      return v ? { key: it.key, qty: it.quantity, id: it.variant_id, value: v, props: it.properties || {} } : null;
    }).filter(Boolean);
  };
  var otherCodes = function (cart, code) {
    var up = code.toUpperCase();
    return (cart.discount_codes || []).filter(function (d) { return d.applicable && String(d.code).toUpperCase() !== up; })
      .map(function (d) { return d.code; });
  };

  function rerender(note) {
    var drawer = document.querySelector('cart-drawer');
    return fetch(window.location.pathname + '?sections=cart-drawer,cart-icon-bubble', { credentials: 'same-origin' })
      .then(function (r) { return r.json(); })
      .then(function (sections) {
        if (drawer && typeof drawer.renderContents === 'function') drawer.renderContents({ sections: sections });
        else if (note) window.location.href = (window.routes && window.routes.cart_url) || '/cart';
        if (note) showNote(note);
        if (typeof publish === 'function' && window.PUB_SUB_EVENTS) {
          getCart().then(function (c) { publish(PUB_SUB_EVENTS.cartUpdate, { source: 'wl-cart-upsell', cartData: c }); });
        }
      });
  }

  function showNote(text) {
    var drawer = document.querySelector('cart-drawer');
    if (!drawer) return;
    if (!document.getElementById('wl-cart-note-css')) {
      var st = document.createElement('style');
      st.id = 'wl-cart-note-css';
      st.textContent = '.wl-cart-note{display:flex;gap:.8rem;align-items:flex-start;margin:0 0 1rem;padding:1rem 1.2rem;border-radius:1.2rem;font-size:1.3rem;line-height:1.35;color:#0a0a0a;background:#fff4ee;box-shadow:inset 0 0 0 1.5px #ff5a1f}.wl-cart-note b{font-weight:700}.wl-cart-note svg{flex:none;width:1.8rem;height:1.8rem;margin-top:.1rem;color:#ff5a1f}';
      document.head.appendChild(st);
    }
    var old = drawer.querySelector('.wl-cart-note');
    if (old) old.remove();
    var n = document.createElement('p');
    n.className = 'wl-cart-note';
    n.setAttribute('role', 'status');
    n.innerHTML = '<svg viewBox="0 0 24 24" aria-hidden="true"><circle cx="12" cy="12" r="10" fill="none" stroke="currentColor" stroke-width="2"/><path d="M12 11v6" stroke="currentColor" stroke-width="2.4" stroke-linecap="round"/><circle cx="12" cy="7.3" r="1.4" fill="currentColor"/></svg><span></span>';
    n.querySelector('span').textContent = text;
    var anchor = drawer.querySelector('.wl-bundle') || drawer.querySelector('.wl-upsell') || drawer.querySelector('.drawer__footer');
    if (anchor) anchor.parentNode.insertBefore(n, anchor);
    else return;
    // même retrait latéral que le bloc voisin (les blocs du tiroir ont leurs propres marges)
    var acs = getComputedStyle(anchor);
    n.style.marginLeft = acs.marginLeft;
    n.style.marginRight = acs.marginRight;
    // reste affiché jusqu'au prochain re-rendu du tiroir (qui remplace son contenu)
    if (n.scrollIntoView) n.scrollIntoView({ block: 'nearest', behavior: 'smooth' });
  }

  function variantsOf(card) {
    var el = card.querySelector('[data-wl-variants]');
    if (!el) return [];
    try { return JSON.parse(el.textContent); } catch (e) { return []; }
  }

  function syncVariant(card) {
    var btn = card.querySelector('[data-wl-upsell-add]');
    var selects = card.querySelectorAll('.wl-upsell__select');
    if (!btn || !selects.length) return;
    var chosen = Array.prototype.map.call(selects, function (s) { return s.value; });
    var match = variantsOf(card).filter(function (v) {
      return v.o.every(function (o, i) { return o === chosen[i]; });
    })[0];
    var ok = match && match.a;
    btn.disabled = !ok;
    if (match) btn.dataset.variantId = match.id;
    var img = card.querySelector('.wl-upsell__media img');
    if (match && match.i && img && img.getAttribute('src') !== match.i) img.setAttribute('src', match.i);
  }

  // Présélectionne la taille déjà présente au panier, si elle est dispo.
  // Une seule fois par carte (data-wl-init) pour ne pas boucler avec l'observer.
  function presetSizes(root) {
    root.querySelectorAll('.wl-upsell').forEach(function (box) {
      var size = box.dataset.wlSize;
      box.querySelectorAll('.wl-upsell__card:not([data-wl-init])').forEach(function (card) {
        card.setAttribute('data-wl-init', '');
        if (size) {
          card.querySelectorAll('.wl-upsell__select').forEach(function (s) {
            if (s.dataset.name !== 'taille' && s.dataset.name !== 'size') return;
            var prev = s.value;
            s.value = size;
            if (s.value !== size) { s.value = prev; return; }
            syncVariant(card);
            var btn = card.querySelector('[data-wl-upsell-add]');
            if (btn && btn.disabled) s.value = prev;
          });
        }
        syncVariant(card);
      });
    });
  }

  document.addEventListener('change', function (e) {
    if (!e.target.classList || !e.target.classList.contains('wl-upsell__select')) return;
    syncVariant(e.target.closest('.wl-upsell__card'));
  });

  document.addEventListener('click', function (e) {
    var btn = e.target.closest && e.target.closest('[data-wl-upsell-add]');
    if (!btn || btn.disabled) return;
    e.preventDefault();
    var drawer = document.querySelector('cart-drawer');
    btn.disabled = true;
    btn.classList.add('is-loading');
    var before = null;

    getCart()
      .catch(function () { return null; })
      .then(function (c) {
        before = c;
        return fetch((window.routes && window.routes.cart_add_url ? window.routes.cart_add_url : '/cart/add') + '.js', {
          method: 'POST',
          headers: JSONH,
          body: JSON.stringify({
            items: [{ id: Number(btn.dataset.variantId), quantity: 1, properties: { _wl_source: btn.dataset.wlSource || 'cart-upsell' } }],
            sections: 'cart-drawer,cart-icon-bubble',
            sections_url: window.location.pathname
          })
        });
      })
      .then(function (r) { return r.json(); })
      .then(function (res) {
        if (res.status || !res.sections) throw new Error(res.description || 'add failed');
        // l'ajout a-t-il cassé 3FOR15 (cadeau automatique qui réserve les hauts) ?
        var was = before && codeState(before, '3FOR15');
        if (was && was.applicable) {
          return getCart().then(function (after) {
            var now = codeState(after, '3FOR15');
            if (now && !now.applicable) {
              // on annule l'ajout : on retire 1 unité de la ligne de ce variant
              var line = (after.items || []).filter(function (it) { return it.variant_id === Number(btn.dataset.variantId); })
                .sort(function (a, b) { return a.final_line_price - b.final_line_price; })[0];
              return (line ? changeLine(line.key, line.quantity - 1) : Promise.resolve()).then(function () { return rerender(M.blocked); });
            }
            if (drawer && typeof drawer.renderContents === 'function') drawer.renderContents(res);
            if (typeof publish === 'function' && window.PUB_SUB_EVENTS) publish(PUB_SUB_EVENTS.cartUpdate, { source: 'wl-cart-upsell', cartData: res });
          });
        }
        if (drawer && typeof drawer.renderContents === 'function') {
          drawer.renderContents(res);
        } else {
          window.location.href = (window.routes && window.routes.cart_url) || '/cart';
        }
        if (typeof publish === 'function' && window.PUB_SUB_EVENTS) {
          publish(PUB_SUB_EVENTS.cartUpdate, { source: 'wl-cart-upsell', cartData: res });
        }
      })
      .catch(function () {
        btn.disabled = false;
        btn.classList.remove('is-loading');
      });
  });

  // Rappel 3FOR15 : applique le code (cookie de réduction Shopify) puis re-rend le tiroir.
  // Les offres patch / porte-clés sont réglées « non cumulables » avec les réductions produit :
  // Shopify garde lui-même la meilleure option. Si 3FOR15 gagne, le cadeau reste au panier à
  // prix normal ; s'il perd, on retire le code. Dans les deux cas un message l'explique.
  document.addEventListener('click', function (e) {
    var btn = e.target.closest && e.target.closest('[data-wl-apply-code]');
    if (!btn || btn.disabled) return;
    e.preventDefault();
    var code = btn.dataset.wlApplyCode;
    var giftValue = 0;
    btn.disabled = true;
    btn.classList.add('is-loading');
    getCart()
      .then(function (before) {
        giftValue = giftLines(before).reduce(function (s, g) { return s + g.value; }, 0);
        return fetch('/discount/' + encodeURIComponent(code) + '?redirect=' + encodeURIComponent('/cart.js'), { credentials: 'same-origin' });
      })
      .then(getCart)
      .then(function (cart) {
        var st = codeState(cart, code);
        var giftNow = giftLines(cart).reduce(function (s, g) { return s + g.value; }, 0);
        if (st && st.applicable) {
          var lost = giftValue - giftNow;
          return rerender(lost > 0 ? M.paid.replace('{gift}', money(lost)).replace('{code}', money(codeSaving(cart, code))) : null);
        }
        if (giftNow > 0) {
          return setCodes(otherCodes(cart, code)).then(function () { return rerender(M.kept.replace('{gift}', '−' + money(giftNow))); });
        }
        return rerender(M.na);
      })
      .catch(function () {
        btn.disabled = false;
        btn.classList.remove('is-loading');
      });
  });

  // Barre livraison : remplit depuis l'ancienne valeur (ou 0 à l'ouverture).
  var lastPct = null;
  function animateBar(root, fromZero) {
    var fill = root.querySelector('.wl-ship__fill');
    if (!fill) { lastPct = null; return; }
    var to = parseFloat(fill.dataset.pct) || 0;
    var isNew = !fill.hasAttribute('data-wl-init');
    if (!isNew && !fromZero) return;
    fill.setAttribute('data-wl-init', '');
    var from = fromZero ? 0 : lastPct;
    lastPct = to;
    if (from === null || from === to) return;
    fill.style.transition = 'none';
    fill.style.width = from + '%';
    void fill.offsetWidth;
    fill.style.transition = '';
    requestAnimationFrame(function () { fill.style.width = to + '%'; });
  }

  // Re-présélection après chaque re-rendu du tiroir.
  function watch() {
    var drawer = document.querySelector('cart-drawer');
    if (!drawer) return;
    presetSizes(drawer);
    var bar = drawer.querySelector('.wl-ship__fill');
    if (bar) { bar.setAttribute('data-wl-init', ''); lastPct = parseFloat(bar.dataset.pct) || 0; }
    if (window.MutationObserver) {
      new MutationObserver(function () { presetSizes(drawer); animateBar(drawer, false); })
        .observe(drawer, { childList: true, subtree: true });
      var wasOpen = drawer.classList.contains('active');
      new MutationObserver(function () {
        var open = drawer.classList.contains('active');
        if (open && !wasOpen) setTimeout(function () { animateBar(drawer, true); }, 250);
        wasOpen = open;
      }).observe(drawer, { attributes: true, attributeFilter: ['class'] });
    }
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', watch);
  else watch();
})();
